import i18n from 'i18next';

import store from './../store';
import { initReactI18next } from 'react-i18next';
import translations from './locales';

i18n
    // pass the i18n instance to react-i18next.
    .use( initReactI18next )
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init( {
        resources: translations,
        lng: store.getState().settingsReducer.lang,
        fallbackLng: 'sk',
        whitelist: [ 'sk', 'cs' ],
        defaultNS: 'translation',
        debug: !store.getState().settingsReducer.productionMode,

        interpolation: {
            escapeValue: false,
        },
        react: {
            useSuspense: false,
        },
    } );


export default i18n;
